// The names and lifetimes of the cookies the session layer sets.
//
// They live here rather than beside the code that writes them for the reason
// `$lib/nav/signed-in-hint` already states about one of them: this module is
// safe to bundle into the browser and the writing side is not, so there is only
// ever one of each value. Two readers need them and neither may import the
// server module — the consent layer's cookie table, which is bundled as its own
// classic script for the pages that ship no framework at all, and the test that
// holds that table to what a browser is actually given.
//
// A lifetime published as prose is a lifetime that can disagree with the
// `Set-Cookie` a browser receives. These numbers are the ones the setters use
// and the ones the table prints, so the two cannot drift.
//
// Browser-safe: no import of any kind.

/** The better-auth session token for the cabinet, presented to the API by us. */
export const SESSION_COOKIE = "sd_session";

// A week; the API session outlives a single visit so the cabinet does not force
// a fresh sign-in on every return.
export const SESSION_MAX_AGE_SECONDS = 60 * 60 * 24 * 7;

/** The address a verification code was just sent to. */
export const PENDING_VERIFICATION_COOKIE = "sd_verify_email";

// Comfortably longer than a single code's lifetime, so a visitor who waits one
// out and asks for another is still on the same errand; short enough that an
// abandoned sign-up does not follow them into a later visit.
export const PENDING_VERIFICATION_MAX_AGE_SECONDS = 30 * 60;

/** That the visitor left the cabinet to sign in again on the way to deleting. */
export const DELETE_CONFIRM_COOKIE = "sd_delete_confirm";

// Long enough for a provider's consent screen, short enough that an abandoned
// errand does not reopen the dialog on a later visit.
export const DELETE_CONFIRM_MAX_AGE_SECONDS = 10 * 60;

/** Where an administrator's own session is parked while they view another. */
export const ADMIN_SESSION_COOKIE = "sd_admin_session";

/** The address being viewed, so the banner saying so is server-rendered. */
export const IMPERSONATING_COOKIE = "sd_impersonating";

// The same half hour the API gives the impersonation session itself, so the two
// expire together and a cookie never outlives the token it describes.
export const IMPERSONATION_MAX_AGE_SECONDS = 30 * 60;
